<template>
  <div class="screenshots">
    <h1>{{ $t("screenshots.title") }}</h1>
    <div class="row">
      <div class="col-md-12 text-right">
        <Json2Csv :json-data="csvData" :csv-title="`Screenshots_Data`">
          <button class="ui-action-button">{{ $t("events.listEvents.donwloadBtn") }}</button>
        </Json2Csv>
      </div>
    </div>
    <v-server-table
      :columns="table_options.columns"
      :options="table_options.options"
      ref="screeshotsTable"
      id="screeshotsTable"
      class="screenshots__table"
    >
      <template #reportDate="props">
        <span>{{props.row.reportDateFormat}}</span>
      </template>
      <template #screenshot="props">
        <div v-if="props.row.screenshot === '' " class="gray">
          <span>No Image</span>
        </div>
        <img @click="openModal(props.row)" v-else class="image-group" :src="props.row.screenshot" />
      </template>
      <template #actions="props">
        <div class="download" v-if="props.row.screenshot !== '' ">
          <a :href="props.row.screenshot" target="_blank" download>
            <img class="mr-2" src="@/assets/img/icon/Download_icon.png" alt="Download Icon" />
            {{ $t("screenshots.downloadScreenshot") }}
          </a>
        </div>
      </template>
    </v-server-table>
    <!-- Modal -->
    <Modal class="screenshots__modal" v-if="modalActive" @closeModal="closeModal">
      <template #header></template>
      <template>
        <div class="screenshots__modal__body">
          <img max-width="100%" width="100%" height="auto" :src="imageObject.screenshot"/>
        </div>
      </template>
      <template #footer>
        <div class="col-md-12 d-flex justify-content-between">
          <p>
            {{$t('reportPhotos.photoOf')}}: <span>{{imageObject.fullName}}</span>
          </p>
          <a class="link" :href="imageObject.screenshot" target="_blank" download>
            <img class="mr-2" src="@/assets/img/icon/Download_icon.png" alt="Download Icon" />
            {{ $t("screenshots.downloadScreenshot") }}
          </a>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/screenshots.js";
import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();
const api = new API_SERVICE();
import Json2Csv from "vue-json-to-csv";
const Modal = () => import("@/components/Modal");
import { getFormattedDate } from  '@/lib/utils';

export default {
  components: {
    Json2Csv,
    Modal,
  },
  data() {
    return {
      table_options: {},
      downloadData: [],
      csvData: [],
      dictionary: {
        fullName: this.$t("screenshots.table.headings.fullName"),
        controlNumber: this.$t("screenshots.table.headings.controlNumber"),
        dateApp: this.$t(
          "screenshots.table.headings.dateApp"
        ),
        section: this.$t("screenshots.table.headings.section"),
        screenshot: this.$t("screenshots.table.headings.screenshot"),
      },
      modalActive: false,
      imageObject: null,
    };
  },
  async beforeMount() {
    this.createTable();
    await this.downloadTable();
  },
  methods: {
    createTable:  function () {
      this.table_options = {
        columns: this.table_columns,
        options: {
          columnsDropdown: false,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [
            "fullName",
            "controlNumber",
            "section",
            "dateApp",
          ],
          orderBy: {
            ascending: false
          },
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort",
          },
          columnsClasses: {
            fullName: 'align-middle',
            controlNumber: 'align-middle',
            section: 'align-middle',
            dateApp: 'align-middle',
            actions: 'align-middle'
          },
          resizableColumns: false,
          perPage: 10,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
          },
          requestAdapter: function (data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.orderBy = data.orderBy ? data.orderBy : "dateApp";
            queries.orderType = data.ascending ? "asc" : "desc";
            return queries;
          },
          requestFunction: async function (data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const response = await api.getScreenshots(data);
              if (response && response.data) {
                const mapData = response.data.map(item => {
                  let formatDate = getFormattedDate(item.dateApp, true);
                  item.dateApp = formatDate;

                  if (item.screenshot) {
                    const signedUrl = s3.getSignedUrl(item.screenshot);
                    item.screenshot = signedUrl;
                  } else {
                    item.screenshot = '';
                  }

                  return item;
                });

                response.data = mapData;
              }
              this.$store.commit("global/SET_LOADING", false);
              return response;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function (response) {
            return {
              data: response.data,
              count: +response.total,
            };
          },
        }
      };
    },
    openModal: function (imgObj) {
      this.modalActive = true;
      this.imageObject = imgObj;
    },
    closeModal: function () {
      this.modalActive = false;
    },
    async downloadTable() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let data = {
          all: true,
          query: {},
        };
        const response = await api.getScreenshots(data);
        if (response && response.data) {
          const mapData = response.data.map(item => {
            item.dateApp  = getFormattedDate(item.dateApp, true);

            if (item.screenshot) {
              const signedUrl = s3.getSignedUrl(item.screenshot);
              item.screenshot = signedUrl;
            } else {
              item.screenshot = '';
            }

            return item;
          });

          response.data = mapData;
        }

        this.downloadData = response.data;

        this.itemsToDownload();
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    itemsToDownload: function () {
      const itemsFields = [
        "fullName",
        "controlNumber",
        "dateApp",
        "section",
        "screenshot",
      ];
      let downloadArray = this.downloadData.map((item) => {
        let obj = {};
        itemsFields.forEach((field) => {
          obj[this._translateHeader(field)] = item[field];
        });

        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    },
  },
  computed: {
    table_columns: function () {
      return [
        "fullName",
        "controlNumber",
        "dateApp",
        "section",
        "screenshot",
        "actions",
      ];
    },
    table_headings: function () {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach((column) => {
          headings[column] = this.$t(`screenshots.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function () {
      return this.table_columns.filter(
        (column) =>
          column !== "actions" &&
          column !== "screenshot" &&
          column !== "dateApp"
      );
    }
  }
};
</script>

<style lang="scss" scoped>

.screenshots {
  &__table {
    text-align: center;
    justify-content: center;
    margin-top: $global-padding * 2;
  }
  &__modal {
    &__body {
      display: flex;
      width: 100%;
      height: auto;
      max-height: 600px;
      max-width: 100%;
    }
  }

  .link {
    color: #000;
  }
  .link:hover {
    color: #000;
  }

  .download a {
    cursor: pointer;
    color: #000;
    &:hover {
      color: #000;
    }
  }

  .gray {
    background-color: #cccccc;
    height: 100px;
    width: 150px;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image-group {
    width: 150px;
    height: 100px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    cursor: pointer;
  }
}

</style>